<template>
  <div class="plan-core-info-view">
    <p class="info-title">方案核心内容&nbsp;&nbsp;{{tableData.length}}</p>

    <div class="plan-core-info-block">
      <div class="table-box ly_table_light">
        <el-table
          :data="tableData"
          border
          style="width: 970px;"
          header-cell-class-name="ly_table_light_header"
        >
          <el-table-column label="内容类型" prop="productType" align="center"></el-table-column>

          <el-table-column label="产品实体编号" prop="newId" align="center"></el-table-column>

          <el-table-column label="产品名称" prop="productName" align="center"> </el-table-column>

          <el-table-column label="产品简介" prop="productIntro" align="center"> </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
// api
import { getSolutionCoreBySolutionId } from "@/api/solvePlan.js"

export default {
  data() {
    //这里存放数据
    return {
      tableData: []
    };
  },
  methods: {
    getInfo() {
      getSolutionCoreBySolutionId({id: this.$route.query.companyCode}).then(res => {
        if(Array.isArray(res.data)) {
          this.tableData = res.data
        }
      })
    }
  }
};
</script>

<style scoped lang="less">
.plan-core-info-view {
  .info-title {
    margin-top: 20px;
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 25px;
  }

  .table-box {
    padding-left: 190px;
    padding-bottom: 10px;
  }
}
</style>
